import { RootState } from 'store'
import { UserProfileDropdown } from './UserProfileDropdown.reducer'

export const userDropdownData = (state: RootState) =>
  state.userDropdownData as UserProfileDropdown
